const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;

export const serializeDateInputToIso = (dateInput: string): string | undefined => {
  const trimmedDateInput = dateInput.trim();
  if (!trimmedDateInput) {
    return undefined;
  }

  const dateMatch = trimmedDateInput.match(DATE_ONLY_PATTERN);
  if (!dateMatch) {
    return undefined;
  }

  const [, year, month, day] = dateMatch;
  return `${year}-${month}-${day}T12:00:00.000Z`;
};

export const getDateInputValue = (dateValue?: string | null): string => {
  if (!dateValue) {
    return '';
  }

  const trimmedDateValue = dateValue.trim();
  if (!trimmedDateValue) {
    return '';
  }

  const dateMatch = trimmedDateValue.match(DATE_ONLY_PATTERN);
  return dateMatch ? dateMatch[0] : '';
};

export const isBirthDateAfterDeathDate = (birthDateInput?: string | null, deathDateInput?: string | null): boolean => {
  const birthDate = getDateInputValue(birthDateInput);
  const deathDate = getDateInputValue(deathDateInput);

  if (!birthDate || !deathDate) {
    return false;
  }

  return birthDate > deathDate;
};
